import { render, staticRenderFns } from "./BankingIcon.vue?vue&type=template&id=cc2a63d6&"
import script from "./BankingIcon.vue?vue&type=script&lang=js&"
export * from "./BankingIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports